import { render, staticRenderFns } from "./VerCrearModal.vue?vue&type=template&id=5058b74b&scoped=true&"
import script from "./VerCrearModal.vue?vue&type=script&lang=ts&"
export * from "./VerCrearModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerCrearModal.vue?vue&type=style&index=0&id=5058b74b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5058b74b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5058b74b', component.options)
    } else {
      api.reload('5058b74b', component.options)
    }
    module.hot.accept("./VerCrearModal.vue?vue&type=template&id=5058b74b&scoped=true&", function () {
      api.rerender('5058b74b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MatrizProducto/VerCrearModal.vue"
export default component.exports